import React from 'react';
import { Alert, Typography } from '@mui/material';

const Notification = ({
    message = "Attention! Your application has been reviewed and returned.  Select 'Edit application' from the Actions menu to see more information.",
}) => {
    return (
        <Alert
            severity="error"
            sx={{
                borderRadius: '8px',
                margin: (theme) => `0 ${theme.spacing(5)}`,
            }}
        >
            <Typography
                sx={{
                    fontWeight: 600,
                }}
            >
                {message}
            </Typography>
        </Alert>
    );
};

export default Notification;
